/**
 * Son navigasyonun geri/ileri (back/forward) olup olmadığını bildirir.
 *
 * Neden gerekiyor: kategori listelerinde manuel scroll restorasyonu var
 * (GenericProductsPage). Kaydetme her ayrılışta yapılıyor ama geri sayılan
 * konumu İLERİ navigasyonda da uygulamak "sayfa alttan açılıyor" şikâyetini
 * üretiyordu — menüden kategoriye girince sayfa eski derin scroll konumuna
 * atlıyordu. Restorasyon yalnızca gerçekten geri/ileri gidildiğinde yapılmalı.
 *
 * İki kaynak var:
 *  - Client-side navigasyon: `popstate` (AppEffects'te dinleniyor, bayrağı yazar)
 *  - Tam sayfa yüklemesi: Navigation Timing API'nin `back_forward` tipi
 */
const BACK_FORWARD_FLAG = "nav_back_forward";

/** Belge ömrü boyunca Navigation Timing sinyali bir kez tüketilir. */
let documentNavConsumed = false;

export const markBackForwardNavigation = (): void => {
  try {
    window.sessionStorage.setItem(BACK_FORWARD_FLAG, "1");
  } catch {}
};

/**
 * Okur ve TÜKETİR — art arda çağrılırsa ikincisi false döner.
 * Sunucuda (SSR) daima false.
 */
export const consumeBackForwardNavigation = (): boolean => {
  if (typeof window === "undefined") return false;

  try {
    if (window.sessionStorage.getItem(BACK_FORWARD_FLAG)) {
      window.sessionStorage.removeItem(BACK_FORWARD_FLAG);
      return true;
    }
  } catch {}

  // Tam sayfa yüklemesiyle geri gelinmiş olabilir. Bu kayıt belge boyunca
  // sabit kaldığı için yalnızca ilk sorguda geçerli sayılır; aksi hâlde aynı
  // belgedeki sonraki ileri navigasyonlar da geri sanılırdı.
  if (!documentNavConsumed) {
    documentNavConsumed = true;
    try {
      const [entry] = performance.getEntriesByType(
        "navigation",
      ) as PerformanceNavigationTiming[];
      return entry?.type === "back_forward";
    } catch {}
  }

  return false;
};
